// src/utils/gtag.js

/**
 * Sends a Google Analytics event.
 * @param {string} action - The event action (e.g., 'sign_up').
 * @param {object} [params] - Optional parameters for the event.
 */
export const gtagEvent = (action, params) => {
  if (window.gtag) {
    window.gtag('event', action, params);
  } else {
    console.warn('window.gtag is not available. Event not sent.');
  }
};